enum ShareDesignCardCopyStateEnum {
	default = 'default',
	success = 'success',
	failed = 'failed'
}

export default ShareDesignCardCopyStateEnum;
